import script from "./SupportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportPage.vue?vue&type=script&setup=true&lang=js"

import "./SupportPage.vue?vue&type=style&index=0&id=0a217651&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a217651"]])

export default __exports__